import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-6 text-center" data-testid="not-found-page">
      <div className="ie-overline text-brand-accent mb-4">404</div>
      <h1 className="font-serif text-6xl md:text-8xl tracking-tight mb-6">A quiet absence.</h1>
      <p className="text-text-secondary mb-10 max-w-md">The page you're looking for has wandered off. Let's return to the atelier.</p>
      <Link to="/" className="ie-btn-primary">Return Home</Link>
    </div>
  );
}
